import {
  adminImportBulkGiftPath,
  adminTreePoolPath,
  adminViewApplicationPath,
  adminViewFundingPath,
  adminApplicationPlantingReportPath,
  viewRegistryPath,
  viewApplicationPath,
  adminViewAccountPath,
  adminViewAccountsMembershipsPath,
  adminViewRegistryPath,
  listMyRegistriesPath,
  applicationPlantingReportPath,
  viewProfilePath,
  adminListAccountsPath,
  adminMonitoringEventPath,
  viewBlogPostCatchAllPath,
  nativeTreeSpeciesPath,
  nativeTreesPath,
  adminViewFundingMatchesPath,
  adminMatchFundingPath,
  adminCreatePurchasePath,
  adminViewBulkPath,
  viewPlantingPath,
  adminViewPlantingPath,
  viewMonitoringEventPath,
  viewProjectDetailPath,
  adminViewProjectPath,
  editPlantingPath,
  adminApplicationRegistrationPath,
  adminAccountPlanterRegistrationPath,
  blogPath,
  listPlantingProjectsPath,
  viewProjectPath,
  fundingDetailPath,
  updateAccountDetailsPath,
  viewAccountBillingDetailsPath,
  viewAccountPaymentMethodsPath,
  updateAccountProfilePath,
  adminListApplicationsPath,
  viewProjectApplicationsPath,
  adminViewProjectApplicationsPath,
  viewProjectPlantingsPath,
  adminViewProjectPlantingsPath,
  supportedProjectsPath,
  adminAddProjectNotesPath,
  adminViewProjectNoteDetailPath,
  viewSupportedProjectPath
} from 'src/config/paths'

import { Breadcrumb } from './breadcrumbs.types'
import { AdminViewAccountBreadcrumb } from './breadcrumbs/AdminViewAccountBreadcrumb'
import { AdminViewAccountUserBreadcrumb } from './breadcrumbs/AdminViewAccountUserBreadcrumb'
import { AdminViewApplicationBreadcrumb } from './breadcrumbs/AdminViewApplicationBreadcrumb'
import { AdminViewBulkBreadcrumb } from './breadcrumbs/AdminViewBulkBreadcrumb'
import { AdminViewFundingBreadcrumb } from './breadcrumbs/AdminViewFundingBreadcrumb'
import { AdminViewPlantingBreadcrumb } from './breadcrumbs/AdminViewPlantingBreadcrumb'
import { AdminViewPlantingMonitoringBreadcrumb } from './breadcrumbs/AdminViewPlantingMonitoringBreadcrumb'
import { AdminViewProjectDetailBreadcrumb } from './breadcrumbs/AdminViewProjectDetailBreadcrumb'
import { MonitoringEventBreadcrumb } from './breadcrumbs/MonitoringEventBreadcrumb'
import { NativeTreeSpeciesBreadcrumb } from './breadcrumbs/NativeTreeSpeciesBreadcrumb'
import { ViewAccountByUriBreadcrumb } from './breadcrumbs/ViewAccountByUriBreadcrumb'
import { ViewApplicationBreadcrumb } from './breadcrumbs/ViewApplicationBreadcrumb'
import { ViewBlogPostBreadcrumb } from './breadcrumbs/ViewBlogPostBreadcrumb'
import { ViewFundingDetailBreadcrumb } from './breadcrumbs/ViewFundingDetailBreadcrumb'
import { ViewPlantingBreadcrumb } from './breadcrumbs/ViewPlantingBreadcrumb'
import { ViewPlantingMonitoringBreadcrumb } from './breadcrumbs/ViewPlantingMonitoringBreadcrumb'
import {
  ViewFundedProjectDetailBreadcrumb,
  ViewProjectDetailBreadcrumb
} from './breadcrumbs/ViewProjectDetailBreadcrumb'
import { ViewProjectNoteDetailBreadcrumb } from './breadcrumbs/ViewProjectNoteDetailBreadcrumb'
import { ViewPublicProjectBreadcrumb } from './breadcrumbs/ViewPublicProjectBreadcrumb'
import { ViewRegistryBreadcrumb } from './breadcrumbs/ViewRegistryBreadcrumb'
import { ViewRegistryByUriBreadcrumb } from './breadcrumbs/ViewRegistryByUriBreadcrumb'

export const customBreadcrumbs: Omit<Breadcrumb, 'href'>[] = [
  // public pages
  {
    path: viewRegistryPath.path,
    breadcrumb: <ViewRegistryByUriBreadcrumb />
  },
  {
    path: viewProfilePath.path,
    breadcrumb: <ViewAccountByUriBreadcrumb />
  },
  {
    path: viewSupportedProjectPath.path,
    breadcrumb: <ViewFundedProjectDetailBreadcrumb />
  },
  {
    path: nativeTreesPath,
    breadcrumb: 'Native trees'
  },
  {
    path: nativeTreeSpeciesPath.path,
    breadcrumb: <NativeTreeSpeciesBreadcrumb />
  },
  {
    path: viewBlogPostCatchAllPath.path,
    breadcrumb: <ViewBlogPostBreadcrumb />
  },
  {
    path: blogPath(),
    breadcrumb: 'News and stories'
  },
  // user pages
  {
    path: viewPlantingPath.path,
    breadcrumb: <ViewPlantingBreadcrumb />
  },
  {
    path: viewMonitoringEventPath.path,
    breadcrumb: <ViewPlantingMonitoringBreadcrumb />
  },
  {
    path: adminListApplicationsPath(),
    breadcrumb: 'Tree requests'
  },
  {
    path: viewApplicationPath.path,
    breadcrumb: <ViewApplicationBreadcrumb />
  },
  {
    path: listMyRegistriesPath,
    breadcrumb: 'My registries'
  },
  {
    path: applicationPlantingReportPath.path,
    breadcrumb: 'Planting report'
  },
  // {
  //   path: updateAccountPaymentMethodPath,
  //   breadcrumb: 'Edit'
  // },
  {
    path: viewAccountPaymentMethodsPath,
    breadcrumb: 'Payment methods'
  },
  {
    path: supportedProjectsPath,
    breadcrumb: 'Supported projects'
  },
  // admin pages
  { path: adminViewBulkPath.path, breadcrumb: <AdminViewBulkBreadcrumb /> },
  { path: adminTreePoolPath, breadcrumb: 'Tree pool' },
  { path: adminImportBulkGiftPath, breadcrumb: 'Import bulk gift' },
  {
    path: adminViewApplicationPath.path,
    breadcrumb: <AdminViewApplicationBreadcrumb />
  },
  {
    path: adminApplicationPlantingReportPath.path,
    breadcrumb: 'Planting report'
  },
  {
    path: adminViewFundingPath.path,
    breadcrumb: <AdminViewFundingBreadcrumb />
  },
  {
    path: adminViewAccountPath.path,
    breadcrumb: <AdminViewAccountBreadcrumb />
  },
  {
    path: adminViewAccountsMembershipsPath.path,
    breadcrumb: <AdminViewAccountUserBreadcrumb />
  },
  {
    path: adminListAccountsPath,
    breadcrumb: 'Accounts'
  },
  {
    path: adminViewRegistryPath.path,
    breadcrumb: <ViewRegistryBreadcrumb />
  },
  {
    path: adminMonitoringEventPath.path,
    breadcrumb: <MonitoringEventBreadcrumb />
  },
  {
    path: adminMatchFundingPath.path,
    breadcrumb: 'Match with application'
  },
  {
    path: adminViewFundingMatchesPath.path,
    breadcrumb: 'View matches'
  },
  {
    path: adminCreatePurchasePath(),
    breadcrumb: 'Create purchase'
  },
  {
    path: adminViewPlantingPath.path,
    breadcrumb: <AdminViewPlantingBreadcrumb />
  },
  {
    path: adminMonitoringEventPath.path,
    breadcrumb: <AdminViewPlantingMonitoringBreadcrumb />
  },
  {
    path: viewProjectDetailPath.path,
    breadcrumb: <ViewProjectDetailBreadcrumb />
  },
  {
    path: viewProjectPlantingsPath.path,
    breadcrumb: 'Planting reports'
  },
  {
    path: adminViewProjectPlantingsPath.path,
    breadcrumb: 'Planting reports'
  },
  {
    path: viewProjectApplicationsPath.path,
    breadcrumb: 'Tree requests'
  },
  {
    path: adminViewProjectPath.path,
    breadcrumb: <AdminViewProjectDetailBreadcrumb />
  },
  {
    path: adminViewProjectApplicationsPath.path,
    breadcrumb: 'Tree requests'
  },
  {
    path: editPlantingPath.path,
    breadcrumb: 'Edit'
  },
  {
    path: adminApplicationRegistrationPath.path,
    breadcrumb: 'Planting experience'
  },
  {
    path: adminAccountPlanterRegistrationPath.path,
    breadcrumb: 'Planting experience'
  },
  {
    path: listPlantingProjectsPath(),
    breadcrumb: 'Projects'
  },
  {
    path: viewProjectPath.path,
    breadcrumb: <ViewPublicProjectBreadcrumb />
  },
  {
    path: fundingDetailPath.path,
    breadcrumb: <ViewFundingDetailBreadcrumb />
  },
  {
    path: updateAccountDetailsPath,
    breadcrumb: 'Edit'
  },
  // {
  //   path: updateAccountBillingDetailsPath,
  //   breadcrumb: 'Edit'
  // },
  {
    path: viewAccountBillingDetailsPath,
    breadcrumb: 'Payment details'
  },
  {
    path: updateAccountProfilePath,
    breadcrumb: 'Edit'
  },
  {
    path: adminAddProjectNotesPath.path,
    breadcrumb: 'Add field note'
  },
  {
    path: adminViewProjectNoteDetailPath.path,
    breadcrumb: <ViewProjectNoteDetailBreadcrumb />
  }
]
